<template>
  <section id="lnb">
    <div class="lnbTop">
      <p class="topTitle">{{ topTitle }}</p>
    </div>
    <div class="lnbBottom">
      <ul>
        <li
          v-for="(menu, index) in bottomList"
          :key="index"
          :class="{
            on:
              $route.meta.category[$route.meta.category.length - 1] ===
              menu.title,
          }"
          @click="$pushQueryString(menu.link)"
        >
          {{ menu.title }}
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';

export default {
  data() {
    return {
      topTitle: '',
      bottomList: [],
    };
  },

  computed: {
    ...mapGetters({
      menuList: 'getMenuList',
    }),

    empDiv() {
      return this.$store.state.userStore.empDiv;
    },
  },

  watch: {
    $route() {
      this.getLnbTopTitle();
      this.getGnbMenuList();
    },
  },

  created() {
    this.getLnbTopTitle();
    this.getGnbMenuList();
  },

  methods: {
    getGnbMenuList() {
      const copy = cloneDeep(this.menuList);

      const validation = menu => {
        if (menu.auth) {
          menu.auth !== this.empDiv ? (menu = '') : menu;
        }

        if (this.topTitle === menu.title) {
          return true;
        }
      };

      this.bottomList = copy.find(validation)?.menuList ?? [];
    },

    getLnbTopTitle() {
      this.topTitle = this.$route.meta.category[0];
    },
  },
};
</script>
